import React from 'react';
import { withRouter } from 'react-router-dom';
import { reduxForm, Field, change  } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Btn } from './../../../components/includes/ui';
import { InputTextField, SelectField, InputDateField, OptionField } from './../../../components/includes/ui/input';
import { Buttons } from './../../../components/includes/container';
import { stringifyQueryString, parseQueryString } from './../../../utilities/utils';
import { formatDateToString } from './../../../utilities/date';

import TEMPLATES from './../../../config/templates';

const validate = values => {

  const errors = {}

  return errors;

}

class PageFilter extends React.Component {

  componentDidMount(){

    const search = parseQueryString(this.props.location.search);

    Object.entries(search).forEach(([key,value]) => {
      this.props.dispatch(change('PageFilter', key, value));
    });

  }

  /*
  ** @Submit
  ** @Description: Submit filter form
  */

  handleSubmitForm = (values) => {
    this.props.history.push(`/pages?${ stringifyQueryString(values) }`);
    this.props.handleSuccess();
  }

  render() {

    const { handleSubmit } = this.props;

    return(

      <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>
        <Grid container spacing={24}>
          <Grid item xs={6}>
            <Field
                name="start"
                component={ InputDateField }
                label="Desde"
                type="date"
            />
          </Grid>
          <Grid item xs={6}>
            <Field
                name="end"
                component={ InputDateField }
                label="Hasta"
                type="date"
            />
          </Grid>
          <Grid item xs={12}>
            <Field
                name="title"
                component={ InputTextField }
                label="Nombre"
                type="text"
            />
          </Grid>
          <Grid item xs={6}>
            <Field
                name="status"
                component={ SelectField }
                label="Estado">
                  <OptionField key="-1" value="all">Todos...</OptionField>
                  <OptionField key="true" value="true">Activo</OptionField>
                  <OptionField key="false" value="false">Bloqueado</OptionField>
            </Field>
          </Grid>
          <Grid item xs={6}>
            <Field
                name="template"
                component={ SelectField }
                label="Template">
                  <OptionField key="1" value="all">Todos...</OptionField>
                  { TEMPLATES.length > 0 && (
                    TEMPLATES.map(role => {
                      return(
                        <OptionField key={ role.key } value={ role.id }>{ role.name }</OptionField>
                      )
                    })
                  )}
            </Field>
          </Grid>
          <Grid item xs={12}>
            <Buttons align="right">
              <Btn aria-label="Aplicar" icon="save" color="primary" type="submit">
                Aplicar
              </Btn>
            </Buttons>
          </Grid>
        </Grid>
      </form>

    )
  }

}

PageFilter = reduxForm({
  form: 'PageFilter',
  validate,
  initialValues: {
    start: formatDateToString(new Date()),
    end: formatDateToString(new Date()),
    status: 'all',
    template: 'all'
  },
  enableReinitialize: true
})(PageFilter);

export default withRouter(PageFilter);
